/**
 * @since 2016-10-24 09:01
 * @author vivaxy
 */

import createLandingPageContainer from '@dp/cmp-prototype-lib/containers/LandingPage';
import CPMLXInit, { defaultParams } from '@dp/cp-component-lib/lib/lxAndHipPolyfill';
import render  from '../lib/render';
import PageWrapper from '../components/PageWrapper';
import LoadingScreenComponent from '../components/LoadingScreenComponent';
import { queryStringArgs, getCookieArgs } from '../lib/util';
import getPageData from '../api/getPageData';
import getShopInfo from '../api/getShopInfo';
import { platformId } from "../config/platformInfo";

const { '_hc.v': hc = '', } = getCookieArgs;

const { pageId, shopId, _fb_: feedback = '' } = queryStringArgs;

const getPageDataPromise = getPageData(pageId);
/**
 * 将页面配置相关信息传递给 lib 包
 */
const pageDataAction = () => {
    return getPageDataPromise;
};

const shopInfoActon = () => {
    return getShopInfo(shopId);
};

const lxInit = () => {
    Promise.all([pageDataAction(), shopInfoActon()])
        .then(([pageInfo, shopInfo]) => {
            const { data, serviceId: activityId = 0, sequence: pageId = 1, } = pageInfo;
            const pageData = JSON.parse(data || '{}');
            const { cid = '', } = pageData.lxAttr || {};

            const { cityId = 1, shopType = -1, shopName='', branchName='' } = shopInfo;

            const branchNameFormat = branchName ? `(${branchName})` : ``;
            const pageName = `${shopName}${branchNameFormat}-大众点评`;

            document.title = pageName;

            /**
             * 初始化 lx 打点的页面基本参数
             * 调用者需传入 bidName, actionId, feedback
             * 初始化时需要自行传入的参数包括：activityId, pageName, hc, cityId, platform, tk
             * cp 包默认填充的参数包括：promoid, pageId, source, emidasRequestId， type
             */
            const defaultLxParamsFromPageInfo = {
                activityId,
                pageName,
                cityId,
                shopId,
                shopType,
                feedback,
                hc: hc.replace(/\"\\\"/, '').replace(/\\\"\"/, '').replace(/.[\d]*$/, ''),
                platform: platformId,
            };

            // PV 发送
            const valLab = {
                custom: {
                    ...defaultParams,
                    ...defaultLxParamsFromPageInfo,
                }
            };
            window.LXAnalytics('pageView', valLab, null, cid || 'c_8q8dyhu7');

            CPMLXInit('CMPLX', defaultLxParamsFromPageInfo, shopType, window._hip || []);
        })
        .catch((e) => {
            console.error(e);
        });
};


export default () => {
    lxInit();
    return render(createLandingPageContainer({
        pageDataAction,
        LoadingScreenComponent,
        PageWrapper: PageWrapper,
    }));
}



// WEBPACK FOOTER //
// ./src/pages/index.js